import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(theme => ({
  container: {
    margin: theme.spacing(1, 0, 0),
    '&:not(.edit-note)': {
      marginBottom: theme.spacing(3),
    },
    '& .notes': {
      '&-new': {
        '&-input': {
          width: '100%',
        },
        '&-actions': {
          marginTop: theme.spacing(1),
          display: 'flex',
          justifyContent: 'flex-end',
        },
      },
    },
  },
  input: {
    ...theme.typography.body2,
    minHeight: theme.spacing(10),
    alignItems: 'flex-start',
  },
  btn: {
    ...theme.typography.caption,
    textTransform: 'none',
  },
}));

export default styles;
